import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from '@mui/material';
import {
  InputV2,
  InputFormatV2,
  DefaultSelectV2,
  TrueFalseSelectV2,
  WidgetV2,
  MalhaSelectV2,
  GerenciaSelectV2,
  PoloSelectV2,
  OptionSelectV2,
  DatePickerV2,
} from '../../../components/v2';
import { masks } from '../../../helpers';
import * as selectorsUsuarios from '../../../store/usuario/reducer';
import * as actionsUsuarios from '../../../store/usuario/actions';

const InformacaoBasica = ({
  id,
  values,
  setValues,
  errors,
  readOnly,
  isAdmin,
  proximaMatricula,
  findProximaMatricula,
}) => {
  useEffect(() => {
    if (!id) findProximaMatricula();
  }, [findProximaMatricula]);

  useEffect(() => {
    setValues({ ...values, matricula: proximaMatricula });
  }, [proximaMatricula]);

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleChangeRole = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value, subRole: '' });
  };

  const onChangePhone = (event) => {
    setValues({ ...values, telefone: masks.removePhoneMask(event.target.value.substring(0, 15)) });
  };

  const getRoleOptions = () => {
    const roles = [
      { id: 'ROLE_ADMIN', nome: 'Administrador' },
      { id: 'ROLE_CROQUI', nome: 'Croqui' },
      { id: 'ROLE_DIGITADOR', nome: 'Digitador' },
      { id: 'ROLE_INSPETOR', nome: 'Inspetor' },
      { id: 'ROLE_AUDITORIA_NSIR', nome: 'Auditoria NSIR' },
    ];
    // if (isAdmin) roles.push({ id: 'ROLE_SUPER_ADMIN', nome: 'Super Administrador' });
    return roles;
  };

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 3 }}>
        <InputV2
          disabled
          label="Matrícula Eletropontes"
          value={id ? values.matricula : proximaMatricula}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <TrueFalseSelectV2
          label="Ativo"
          showEmpty={false}
          onChange={() => setValues({ ...values, ativo: !values.ativo })}
          value={values.ativo}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <InputV2
          error={errors && errors.nome}
          isRequired
          label="Nome Completo"
          name="nome"
          onChange={handleChange}
          value={values.nome}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 5 }}>
        <InputV2
          error={errors && errors.email}
          isRequired
          label="Login"
          name="email"
          onChange={handleChange}
          value={!readOnly ? values.email : '**********'}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="Apelido"
          name="apelido"
          onChange={handleChange}
          value={values.apelido}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <InputV2
          label="Matrícula Cemig"
          name="matriculaCemig"
          onChange={handleChange}
          value={values.matriculaCemig}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 5 }}>
        <InputV2
          label="Email Corporativo"
          name="emailCorporativo"
          onChange={handleChange}
          value={values.emailCorporativo}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="Email Pessoal"
          name="mail"
          onChange={handleChange}
          value={values.mail}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <InputFormatV2
          label="Telefone"
          name="telefone"
          onChange={onChangePhone}
          value={values.telefone}
          format="(##) #####-####"
          disabled={readOnly}
          mask="_"
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <DefaultSelectV2
          error={errors && errors.role ? true : false}
          isRequired
          label="Perfil"
          name="role"
          showEmpty
          options={getRoleOptions()}
          onSelect={handleChangeRole}
          value={values.role}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <DefaultSelectV2
          error={errors && errors.subRole ? true : false}
          isRequired={values.role === 'ROLE_INSPETOR'}
          label="Sub-Perfil"
          name="subRole"
          showEmpty
          options={[
            { id: 'SUBROLE_OBSERVADOR', nome: 'Observador Operador de RPA' },
            { id: 'SUBROLE_INSPETOR', nome: 'Inspetor Operador de RPA' },
            { id: 'SUBROLE_OPERADOR_MAQUINA', nome: 'Operador de Máquina' },
          ]}
          onSelect={(event) => setValues({ ...values, [event.target.name]: event.target.value || null })}
          value={values.subRole}
          disabled={readOnly || values.role !== 'ROLE_INSPETOR'}
        />
      </Grid>
      <Grid size={{ xs: 3 }}>
        <OptionSelectV2
          label="Setor"
          codigo="USUARIO_SETOR"
          onSelect={(value) => setValues({ ...values, setorId: value })}
          value={values.setorId}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 2 }}>
        <TrueFalseSelectV2
          label="Supervisor"
          showEmpty={false}
          onChange={(event) => setValues({ ...values, supervisor: event.target.value === 'true' })}
          value={values.supervisor === true || values.supervisor === 'true' ? 'true' : 'false'}
          disabled={readOnly}
        />
      </Grid>
      {!readOnly && (
        <>
          <Grid size={{ xs: 12 }}>
            <WidgetV2 title="Recurso Humanos">
              <Grid container spacing={3} sx={{ p: 3 }}>
                <Grid size={{ xs: 3 }}>
                  <OptionSelectV2
                    label="Regime de Trabalho"
                    codigo="USUARIO_REGIME_TRABALHO"
                    onSelect={(value) => setValues({ ...values, regimeTrabalhoId: value })}
                    value={values.regimeTrabalhoId}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid size={{ xs: 9 }}>
                  <OptionSelectV2
                    label="Cargo"
                    codigo="USUARIO_CARGO"
                    onSelect={(value) => setValues({ ...values, cargoId: value })}
                    value={values.cargoId}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <TrueFalseSelectV2
                    label="Possui Carteira Assinada"
                    onChange={(event) => setValues({ ...values, possuiCarteira: event.target.value || null })}
                    value={values.possuiCarteira}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <DatePickerV2
                    label="Data Admissão"
                    onChange={(data) => setValues({ ...values, dataAdmissao: data.valueOf() })}
                    value={values.dataAdmissao}
                    showInput
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <DatePickerV2
                    label="Data Demissão"
                    onChange={(data) => setValues({ ...values, dataDemissao: data.valueOf() })}
                    value={values.dataDemissao}
                    showInput
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <InputV2
                    label="Informações Adicionais"
                    name="informacoesAdicionais"
                    onChange={handleChange}
                    value={values.informacoesAdicionais}
                    rows={4}
                    multiline
                  />
                </Grid>
              </Grid>
            </WidgetV2>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <WidgetV2 title="Local de Trabalho">
              <Grid container spacing={3} sx={{ p: 3 }}>
                <Grid size={{ xs: 12 }}>
                  <MalhaSelectV2
                    onSelect={(value) => setValues({ ...values, additions: { ...values.additions, malhaIds: value } })}
                    value={values.additions?.malhaIds}
                    multiSelect
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <GerenciaSelectV2
                    onSelect={(value) => setValues({ ...values, additions: { ...values.additions, gerenciaIds: value } })}
                    value={values.additions?.gerenciaIds}
                    multiSelect
                    useFilter
                    malhaId={values.additions?.malhaIds}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <PoloSelectV2
                    onSelect={(value) => setValues({ ...values, additions: { ...values.additions, poloIds: value } })}
                    value={values.additions?.poloIds}
                    isMultiple
                    useFilter
                    malhaId={values.additions?.malhaIds}
                    gerenciaId={values.additions?.gerenciaIds}
                  />
                </Grid>
              </Grid>
            </WidgetV2>
          </Grid>
        </>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  proximaMatricula: selectorsUsuarios.getProximaMatricula(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsUsuarios }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InformacaoBasica);
